import { appConfig, LogLevel } from "@webcore/config/appConfig.ts";

export class Logger {
  private readonly logKey: string;

  public constructor(logKey: string) {
    this.logKey = logKey;
  }

  public info(message: string, arg?: any) {
    if (!appConfig.logKeysEnabled.has(this.logKey.toLowerCase())) {
      return;
    }
    Log.info(`${this.logKey}: ${message}`, arg);
  }

  public debug(message: string, arg?: any) {
    if (!appConfig.logKeysEnabled.has(this.logKey.toLowerCase())) {
      return;
    }
    Log.debug(`${this.logKey}: ${message}`, arg);
  }

  public error(message: string, arg?: any) {
    if (!appConfig.logKeysEnabled.has(this.logKey.toLowerCase())) {
      return;
    }
    Log.error(`${this.logKey}: ${message}`, arg);
  }

  public warn(message: string, arg?: any) {
    if (!appConfig.logKeysEnabled.has(this.logKey.toLowerCase())) {
      return;
    }
    Log.warn(`${this.logKey}: ${message}`, arg);
  }
}

export default class Log {
  public static createLogger(logKey: string): Logger {
    return new Logger(logKey);
  }

  public static debug(message: string, arg?: any) {
    if (appConfig.logLevel < LogLevel.Debug) {
      return;
    }

    if (arg) {
      console.log(message, arg);
    }
    else {
      console.log(message);
    }
  }

  public static info(message: string, arg?: any) {
    if (appConfig.logLevel < LogLevel.Info) {
      return;
    }

    if (arg) {
      console.log(message, arg);
    }
    else {
      console.log(message);
    }
  }

  public static error(message: string, arg?: any) {
    if (appConfig.logLevel < LogLevel.Error) {
      return;
    }

    if (arg) {
      console.error(message, arg);
    }
    else {
      console.error(message);
    }
  }

  public static warn(message: string, arg?: any) {
    if (appConfig.logLevel < LogLevel.Warning) {
      return;
    }

    if (arg) {
      console.warn(message, arg);
    }
    else {
      console.warn(message);
    }
  }
}
